import { Stack, Typography, Button, Box, Divider } from '@mui/material';
import SiloRealLogo from '../../assets/logos/siloreal-logo-black.webp';
import { useNavigate } from 'react-router';
import { ModalIOF } from '@old/ui/modal/modal';

// Swiss Re
import porotoSwissRe from '../../assets/svg/icons-species-swissre/bean-swissre.svg';
import maizSwissRe from '../../assets/svg/icons-species-swissre/maiz-swissre.svg';
import arrozSwissRe from '../../assets/svg/icons-species-swissre/rice-swissre.svg';
import sojaSwissRe from '../../assets/svg/icons-species-swissre/soja-swissre.svg';
import trigoSwissRe from '../../assets/svg/icons-species-swissre/trigo-swissre.svg';

import { PATH } from '@old/data/core/paths';
import { useGlobalStore } from '@old/global-store/use-store';
import { useService } from '@old/hooks/use-service';
import { updateUserDataService } from '@old/services/domain/user/base/user-edition';

type InsuranceIntegrationModalProps = {
  type: 'swissre';
  open: boolean;
  setOpen: (value: boolean) => void;
};

export function InsuranceIntegrationPopUpModalBR(props: InsuranceIntegrationModalProps) {
  const { userID, setIshowOneModal } = useGlobalStore();

  const { trigger } = useService(updateUserDataService);
  const navigate = useNavigate();

  const { open, setOpen } = props;

  const ENTITY_MAP = {
    swissre: 'Swiss Re',
  };
  const LOGO_MAP = {
    swissre: 'https://iofbucket.s3.amazonaws.com/logo/SwissRE%20Logo%20Color.svg',
  };

  const SPECIES_MAP = {
    swissre: {
      poroto: porotoSwissRe,
      maiz: maizSwissRe,
      arroz: arrozSwissRe,
      soja: sojaSwissRe,
      trigo: trigoSwissRe,
    },
  };

  const CALL_TO_ACTION_STYLES_MAP = {
    swissre: {
      background: 'linear-gradient(45deg, #4a5f59 0%, #627d77 67%, #CEDBD8 100%)',
      boxShadow: '0px 3px 6px rgba(98, 125, 119, 0.4)',
      '&:hover': {
        background: 'linear-gradient(45deg, #5a6f69 0%, #728d87 67%, #CEDBD8 100%)',
        boxShadow: '2px 5px 8px rgba(98, 125, 119, 0.6)',
      },
    },
  };

  const insurance = {
    enterprise: ENTITY_MAP[props.type],
    logo: LOGO_MAP[props.type],
    speciesIcon: {
      poroto: SPECIES_MAP[props.type].poroto,
      maiz: SPECIES_MAP[props.type].maiz,
      arroz: SPECIES_MAP[props.type].arroz,
      soja: SPECIES_MAP[props.type].soja,
      trigo: SPECIES_MAP[props.type].trigo,
    },
    callToActionStyles: CALL_TO_ACTION_STYLES_MAP[props.type],
  };

  const updateShownPopupFlag = () => {
    const body = {
      swissre: { was_swissre_popup_shown: true },
    };
    trigger({
      query: userID!,
      body: body[props.type],
    });
  };
  const handleClose = () => {
    setOpen(true);
    setIshowOneModal(true);
  };
  const handleCancelInsurance = () => {
    updateShownPopupFlag();
    handleClose();
  };
  const handleGoToQuote = () => {
    updateShownPopupFlag();
    handleClose();
    navigate(PATH.SILOBAG);
  };

  return (
    <ModalIOF open={open} ModalIsOpen={setOpen} width="48%">
      <ModalIOF.HeaderCenter>
        <ModalIOF.Title>
          <Stack direction="row" spacing={2} justifyContent="space-around" alignItems="center">
            <Box>
              <img src={SiloRealLogo} alt="SiloReal Logo" style={{ width: '144px', padding: 10 }} />
            </Box>
            <Divider orientation="vertical" flexItem />

            <img src={insurance.logo} alt={`${insurance.enterprise} Logo`} style={{ width: '175px' }} />
          </Stack>
        </ModalIOF.Title>
      </ModalIOF.HeaderCenter>
      <ModalIOF.Body>
        <Stack direction="column" spacing={2} sx={{ textAlign: 'center' }}>
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            Nova parceria com {insurance.enterprise}
          </Typography>
          <Stack direction={'row'} justifyContent={'center'}>
            <Box>
              <img
                src={insurance.speciesIcon.poroto}
                alt="Feijão"
                style={{ width: '50px', margin: '15px 25px 10px 25px' }}
              />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Feijão
              </Typography>
            </Box>
            <Box>
              <img
                src={insurance.speciesIcon.maiz}
                alt="Milho"
                style={{ width: '50px', margin: '15px 25px 10px 25px' }}
              />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Milho
              </Typography>
            </Box>
            <Box>
              <img
                src={insurance.speciesIcon.arroz}
                alt="Arroz"
                style={{ width: '50px', margin: '15px 25px 10px 25px' }}
              />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Arroz
              </Typography>
            </Box>
            <Box>
              <img
                src={insurance.speciesIcon.soja}
                alt="Soja"
                style={{ width: '50px', margin: '15px 25px 10px 25px' }}
              />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Soja
              </Typography>
            </Box>
            <Box>
              <img
                src={insurance.speciesIcon.trigo}
                alt="Trigo"
                style={{ width: '50px', margin: '15px 25px 10px 25px' }}
              />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Trigo
              </Typography>
            </Box>
          </Stack>
        </Stack>
        <Box sx={{ margin: '20px 0px' }}>
          <Typography
            sx={{
              margin: 'auto',
              width: '600px',
              fontSize: '19px',
              textAlign: 'center',
              textWrap: 'balance',
            }}
          >
            Agora você poderá contratar coberturas de seguro da Swiss Re a partir da plataforma{' '}
            <span style={{ fontWeight: 600 }}>
              {insurance.enterprise}
              da SiloReal
            </span>
          </Typography>
        </Box>
        <Stack direction="row" spacing={2} justifyContent={'center'}>
          <Button
            color="error"
            sx={{ border: 'none', color: 'black', textTransform: 'none' }}
            onClick={handleCancelInsurance}
          >
            Talvez mais tarde
          </Button>
          <Button
            variant="contained"
            sx={{
              color: '#FFF',
              fontSize: 14,
              borderRadius: 100,
              textTransform: 'none',
              padding: '0px 30px',
              margin: '10px',
              ...insurance.callToActionStyles,
            }}
            onClick={handleGoToQuote}
          >
            Cotar Seguro
          </Button>
        </Stack>
      </ModalIOF.Body>
    </ModalIOF>
  );
}
